import { HttpClient } from '@shared/adapters/HttpClient';

export interface InvalidPersonalDataErrorRequest {
  customer: {
    name: string;
    phone: string;
    email?: string;
  };
}

export interface InvalidPersonalDataErrorResponse {
  success: boolean;
  message: string;
}

export class InvalidPersonalDataErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solveInvalidPersonalDataError(
    orderId: number,
    data: InvalidPersonalDataErrorRequest
  ): Promise<InvalidPersonalDataErrorResponse> {
    try {
      console.log(
        '🔍 InvalidPersonalDataErrorApiAdapter - Solving invalid personal data error:',
        {
          orderId,
          data,
        }
      );

      const response = await this.httpClient.put(
        `/orders/${orderId}/solve-error/personal`,
        data
      );

      console.log(
        '🔍 InvalidPersonalDataErrorApiAdapter - Response:',
        response
      );

      return {
        success: true,
        message:
          response.message || 'Datos personales actualizados correctamente',
      };
    } catch (error: any) {
      console.log('🔍 InvalidPersonalDataErrorApiAdapter - Error:', error);
      throw error;
    }
  }
}
